export default "__VITE_ASSET__89606a2b__"